<div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="container-fluid  p-0" *ngIf="isLoaded()">
    <ng-container *ngIf="contractList && contractList.length > 0; else noContracts">
      <div class="row m-t-xs">
        <div class="col-12">
          <span class="float-right leyenda">{{contractList.length}} {{'Contracts.counter'|translate}}</span>
        </div>
      </div>
      <ng-container *ngFor="let contract of contractList">
        <div class="row">
          <div class="col-12">
            <p-panel styleClass="mb-3" [toggleable]="true" [collapsed]="
            this.collapsedContracts[contract.division.identifier]==true
            || this.collapsedContracts[contract.division.identifier]==undefined &&
            (
              (divisionId&&contract.division.identifier!=divisionId)
              || (!divisionId&&contractList.length>1)
              )" (onAfterToggle)="loadOneContract($event,contract)">
              <p-header><span><i class="fa fas fa-lg fa-file-contract"></i><strong>
                    {{contract.division.name}}</strong></span>
              </p-header>
              <p-tabView *ngIf="isContractExecutionEnabled()" (onChange)="handleChange($event, contract)"
                [activeIndex]="this.selectedContractTabs[contract.division.identifier]">
                <p-tabPanel cache="false" header="{{'Contracts.panel.registerData' | translate}}">
                  <ng-container *ngTemplateOutlet="contractInfo; context: { contract: contract }">
                  </ng-container>
                </p-tabPanel>
                <p-tabPanel *ngIf="isExecutionDivisionVisible(contract)" cache="false"
                  header="{{'Contracts.panel.contractExecution' | translate}}">
                  <ng-container *ngTemplateOutlet="contractExecution; context: { contract: contract }">
                  </ng-container>
                </p-tabPanel>
                <p-tabPanel cache="false" header="{{'Contracts.panel.kpis' | translate}}"
                  *ngIf="kpisRecords && kpisRecords.length>0">
                  <ng-container *ngTemplateOutlet="contractKpis; context: { contract: contract }">
                  </ng-container>
                </p-tabPanel>
                <p-tabPanel cache="false"
                  *ngIf="contract.continuationDossierTracing && isExecutionMonitoringModuleEnabled()"
                  header="{{'Contracts.panel.continuationDossierPlan' | translate}}">
                  <ng-container *ngTemplateOutlet="continuationDossierPlan; context: { contract: contract }">
                  </ng-container>
                </p-tabPanel>
              </p-tabView>
              <ng-container *ngIf="!isContractExecutionEnabled ()">
                <ng-container *ngTemplateOutlet="contractInfo; context: { contract: contract }">
                </ng-container>
              </ng-container>
            </p-panel>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<!-- TEMPLATE PARA CUANDO NO HAY CONTRATOS -->
<ng-template #noContracts>
  <div class="alert alert-info m-b-xs text-ellipsis col-12" role="alert">
    <span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'Contracts.noContracts' | translate
      }}</span>
  </div>
</ng-template>
<!-- TEMPLATE PARA EL CONTENIDO DEL PANEL DEL CONTRATO -->
<ng-template #contractInfo let-contract="contract">
  <ng-container *ngTemplateOutlet="contractBasicInfo; context: { contract: contract }">
  </ng-container>
  <ng-container
    *ngIf="contract.procurementProjectInfo && contract.procurementProjectInfo.apportioned && contract['LOTES'] && contract['LOTES'].length > 0">
    <ng-container *ngTemplateOutlet="contractLots; context: { contract: contract }">
    </ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="contractDocs; context: { contract: contract }">
  </ng-container>
  <ng-container *ngIf="contract.registrationNumber">
    <ng-container *ngTemplateOutlet="contractModifications; context: { contract: contract, onlyExtensions: fakse, title: 'Contracts.Modifications.title' }">

    </ng-container>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LOS DATOS BASICOS DEL CONTRATO -->
<ng-template #contractBasicInfo let-contract="contract">
  <h2 class="mt-1 mb-3 titleElement">{{'Contracts.titleContractData' | translate}}</h2>
  <div class="row mt-1">
    <div class="col-12 col-md-12">
      <dl class="row">
        <dt class="col-12 col-md-2">{{'Sistema Inscripción'| translate}}:</dt>
        <dd class="col-12 col-md-10">
          <span>{{contract.isProjectReplyca?'REPLYCA':'RECON'}}</span>
        </dd>
      </dl>
    </div>
    <div class="col-12 col-md-4">
      <dl class="row">
        <dt class="col-12 col-md-6">{{'Contracts.registerNum'| translate}}:</dt>
        <dd class="col-12 col-md-6">
          <span>{{contract.registrationNumber}}</span>
        </dd>
        <dt class="col-12 col-md-6">{{'General.date.ini'|translate}}:</dt>
        <dd class="col-12 col-md-6">
          <span *ngIf="contract.plannedPeriod"> {{contract.plannedPeriod.startDate | date: 'dd/MM/yyyy'}}</span>
          <span *ngIf="!contract.plannedPeriod"> - /</span>
        </dd>
        <dt class="col-12 col-md-6">{{'DocumentState.state' | translate}}:</dt>
        <dd class="col-12 col-md-6">
          <span [ngClass]="(contract.document.currentState.type.identifier == '70<>TIPOESTADO')?'bg-success':''"
            *ngIf="this.project.status.situation!='Cancelled' && contract.document && contract.document.currentState && contract.document.currentState.type"
            class="badge badge-secondary"> {{contract.document.currentState.type.description}}</span>
          <span [ngClass]="(contract.document.currentState.type.identifier == '70<>TIPOESTADO')?'bg-success':''"
            *ngIf="this.project.status.situation=='Cancelled'" class="badge badge-danger">
            {{'DossierDetail.situation.canceled' | translate}}</span>
        </dd>
      </dl>
    </div>
    <div class="col-12 col-md-8">
      <dl class="row mb-0">
        <dt class="col-12 col-md-5"><span *ngIf="contract.isProjectReplyca">{{'Contracts.data.execitionTerm'|
            translate}}:</span></dt>
        <dd class="col-12 col-md-4 p-md-0">
          <span *ngIf="contract.isProjectReplyca">
            <span *ngIf="contract.plannedPeriod&&contract.plannedPeriod.initialExecutionPeriodText">
              {{contract.plannedPeriod.initialExecutionPeriodText}} </span>
            <strong>
              <span *ngIf="contract.plannedPeriod&&contract.plannedPeriod.finalExecutionPeriodText">/
                {{contract.plannedPeriod.finalExecutionPeriodText}}</span>
            </strong>
          </span>
        </dd>
        <small class="col-12 col-md-3 pl-md-0 pr-md-2"><span
            *ngIf="contract.isProjectReplyca">{{'Contracts.data.termExpired'|translate}}:
            {{contract.plannedPeriod.expiredPeriod}} % <p-slider [(ngModel)]="contract.plannedPeriod.expiredPeriod"
              disabled="true"></p-slider></span></small>
        <dt class="col-12 col-md-5">{{'Contracts.data.endDate'|translate}}:</dt>
        <dd class="col-12 col-md-4 p-md-0">
          <span *ngIf="contract.plannedPeriod && contract.plannedPeriod.endDate"> {{contract.plannedPeriod.endDate |
            date: 'dd/MM/yyyy'}} </span>
          <span *ngIf="contract.plannedPeriod && contract.plannedPeriod.finalEndDate"> -
            <strong>{{contract.plannedPeriod.finalEndDate | date: 'dd/MM/yyyy'}} </strong></span>
        </dd>
        <dt class="col-12 col-md-5">{{'Contracts.data.initialAmount'|translate}}:</dt>
        <dd class="col-12 col-md-4 p-md-0">
          <span
            *ngIf="contract.budget && contract.budget.awardAmount && contract.budget.awardAmount.amountExcludingTaxes">{{contract.budget.awardAmount.amountExcludingTaxes
            | currency: 'EUR'}}</span>
          <span
            *ngIf="contract.budget && contract.budget.awardAmount && !contract.budget.awardAmount.amountExcludingTaxes">{{contract.budget.awardAmount.totalAmount
            | currency: 'EUR'}}</span>
          <span *ngIf="contract.budget && contract.budget.currentAmountExcludingTaxes"> -
            <strong>{{contract.budget.currentAmountExcludingTaxes | currency: 'EUR'}} </strong></span>
        </dd>
        <small class="col-12 col-md-3 pl-md-0 pr-md-2">{{'Contracts.data.amountExecuted'|translate}}:
          {{executionPercent}} %<p-slider [(ngModel)]="executionPercent" disabled="true">
          </p-slider>
        </small>
        <dt class="col-12 col-md-5">{{'Contracts.data.initialGuarantee'|translate}}:</dt>
        <dd class="col-12 col-md-4 p-md-0">
          <span *ngIf="contract.contractSummary && contract.contractSummary.initialWarrantyReturnDate">
            {{contract.contractSummary.initialWarrantyReturnDate | date: 'dd/MM/yyyy'}} </span>
          <span *ngIf="contract.contractSummary && contract.contractSummary.warrantyReturnDate">-<strong>
              {{contract.contractSummary.warrantyReturnDate | date: 'dd/MM/yyyy'}} </strong></span>
        </dd>
        <small class="col-12 col-md-3 pl-md-0 pr-md-2">{{'Contracts.data.guaranteeTerm'|translate}}:
          {{guaranteePercent}} %<p-slider [(ngModel)]="guaranteePercent" disabled="true">
          </p-slider>
        </small>
      </dl>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE VISUALIZACION DE LOTES DEL CONTRATO -->
<ng-template #contractLots let-contract="contract">
  <h2 class="mt-3 mb-3 titleElement">{{'Contracts.titleContractLots'| translate}}</h2>
  <div class="lotes">
    <div class="p-table ui-widget p-table-responsive">
      <div class="p-table-wrapper">
        <table style="width: 100%;">
          <thead class="p-table-thead"></thead>
          <tbody class="p-table-tbody">
            <tr *ngFor="let lot of contract.LOTES">
              <td style="width: 75px;">
                <span class="p-column-title">{{'Contracts.lots.title' | translate}}</span> {{'Contracts.lots.title' |
                translate}} {{lot.lot.lotNumber}}
              </td>
              <td>{{lot.lot.description}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE DOCUMENTOS DESTACADOS DEL CONTRATO -->
<ng-template #contractDocs let-contract="contract">
  <ng-container *ngIf="contract['EXT_DATA_DOCUMENTS'] && contract['EXT_DATA_DOCUMENTS'].length > 0">
    <h2 class="mt-3 mb-3 titleElement">{{'Contracts.titleContractDocuments'| translate}}</h2>
    <span class="m-xs" *ngIf="!contract['EXT_DATA_DOCUMENTS_LOADED']" class="leyenda">
      <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.Documents.loading'| translate}} </span>
    <div class="p-table ui-widget" *ngIf="contract['EXT_DATA_DOCUMENTS_LOADED']">
      <div class="p-table-wrapper">
        <table>
          <thead class="p-table-thead">
            <tr>
              <th style="width: 35%;">{{'General.document'|translate}}</th>
              <th class="text-center" style="width: 20%;">{{'General.date.text'| translate}}</th>
              <th style="width: 25%;">{{'DocumentFile.signers' | translate}}</th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody class="p-table-tbody">
            <tr *ngFor="let doc of contract['EXT_DATA_DOCUMENTS']">
              <td>
                <span><i aria-hidden="true" class="far fa-file-alt px-1 fa-1-5x"></i>{{doc.name}}</span>
              </td>
              <td class="text-center"> {{(doc.currentState?doc.currentState.date: doc.date) | date: 'dd/MM/yyyy
                HH:mm:ss'}} </td>
              <td class="text-left">
                <span> {{getFirmantes(doc)}} </span>
              </td>
              <td class="text-right">
                <div class="btn-group">
                  <button appNoDblClick aria-expanded="false" class="btn btn-sm btn-outline-secondary"
                    title="Visualizar" (click)="viewDocument (doc)">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE INCIDENCIAS DEL CONTRATO -->
<!--<ng-template #contractModifications let-contract="contract">-->
<ng-template #contractModifications let-contract="contract" let-onlyExtensions="onlyExtensions" let-title="title">
  <!-- SE MUESTRA SI HAY INCIDENCIAS O SE PUEDEN CREAR -->
  <ng-container *ngIf="
    (contract['EXT_DATA_CONTRACTMODIFICATIONS'] && contract['EXT_DATA_CONTRACTMODIFICATIONS'].length > 0)
    || isNewContractModificationVisible ()">
    <!--<h2 class="mt-3">{{'Contracts.Modifications.title'|translate}}</h2>-->
    <h2 class="mt-4 mb-3 titleElement">{{title|translate}}</h2>
    <div class="alert alert-info col-12" role="alert"
      *ngIf="!canCreateNewContractModifications(contract) && contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']; else contractModificationsList">
      <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
        contractModificationNoAvailableText(contract) }}</span>
    </div>
    <span class="m-xs" *ngIf=" !contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']" class="leyenda">
      <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.Modifications.loading'| translate}}
    </span>
    <ng-template #contractModificationsList>
      <ng-container
      *ngIf="contract['EXT_DATA_CONTRACTMODIFICATIONS'] && contract['EXT_DATA_CONTRACTMODIFICATIONS'].length > 0">
      <div class="p-table ui-widget" *ngIf="contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']">
        <div class="p-table-wrapper">
          <p-table [value]="contract['EXT_DATA_CONTRACTMODIFICATIONS']" [responsive]="true">
            <ng-template pTemplate="header">
              <tr>
                <th [style.width]="'20%'">{{'General.type'|translate}}</th>
                <th [style.width]="'30%'">{{'General.description'| translate}}</th>
                <th [style.width]="'15%'">{{'DocumentState.state' | translate}}</th>
                <th [style.width]="'15%'">{{'Contracts.registerNum' | translate}}</th>
                <th [style.width]="'20%'">{{'Sistema Inscripción' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-modif>
              <tr>
                <td><span class="p-column-title">{{'General.type'|translate}}</span> {{modif.name}} </td>
                <td><span class="p-column-title">{{'General.description'| translate}}</span> {{modif.reason}}</td>
                <td class="text-truncate w-100"><span class="p-column-title">{{'DocumentState.state' |
                    translate}}</span>
                  <span *ngIf="modif.customFields && modif.customFields.ESTADO_DOC_FRCFI_FI"
                    [ngClass]="(modif.customFields.ESTADO_DOC_FRCFI_FI == 'Inscrito')?'bg-success':''"
                    class="badge badge-secondary"> {{modif.customFields.ESTADO_DOC_FRCFI_FI}} </span>
                  <span
                    *ngIf="(!modif.customFields || !modif.customFields.ESTADO_DOC_FRCFI_FI) && modif.document && modif.document.currentState && modif.document.currentState.type.description"
                    [ngClass]="(modif.document.currentState.type.identifier == '70<>TIPOESTADO')?'bg-success':''"
                    class="badge badge-secondary"> {{modif.document.currentState.type.description}}</span>
                </td>
                <td><span class="p-column-title">{{'Contracts.registerNum' | translate}}</span>
                  <span *ngIf="modif.registerNumber">{{modif.registerNumber}}</span>
                </td>
                <td> {{(modif.isRegisterContractModificationReplyca!=null &&
                  modif.isRegisterContractModificationReplyca!=undefined)?(modif.isRegisterContractModificationReplyca?'REPLYCA':'RECON'):''}}
                </td>
                <!-- <td class="text-right" *ngIf="isContractModificationVisible(contract)">
                  <pmenu-actions [dto]="modif" [lazy]="false" [dtoType]="'CONTRACTMODIFICATION'"
                    [items]="getContractModificationMenuItem(modif)">
                  </pmenu-actions>
                </td> -->
                <td *ngIf="contract.division && contract.division.project
                && contract.division.project.documentClass.identifier !== '00600' && isNewContractModificationVisible()" class="text-right">
                  <div class="btn-group">
                    <!--<button *ngIf="modif.identifier" appNoDblClick (click)="openContractModification (modif)"
                      class="btn btn-sm btn-outline-secondary" pTooltip="Editar Incidencia">
                      <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                    </button>-->
                    <button *ngIf="contractModificationWebAvailable(modif)" appNoDblClick (click)="openContractModificationReadOnly (modif)"
                      class="btn btn-sm btn-outline-secondary" pTooltip="Visualizar Incidencia">
                      <span><i aria-hidden="true" class="far fa-file-alt"></i></span>
                    </button>
                    <button appNoDblClick (click)="openContractModificationAntecedent (contract, modif)"
                      class="btn btn-sm btn-outline-secondary" pTooltip="Antecedentes">
                      <span><i aria-hidden="true" class="fas fa-history"></i></span>
                    </button>
                    <button *ngIf="modif.document && modif.document.identifier"
                      class="btn  btn-primary btn-sm t-action-button" pTooltip="Visualizar documento"
                      [routerLink]="['/documentViewer', modif.document.identifier]"
                      title="{{ 'General.visualize' | translate}}">
                      <i class="fa fa-eye" aria-hidden=" true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isNewContractModificationVisible()">
      <ng-container *ngTemplateOutlet="newContractModifications; context: { contract: contract }"></ng-container>
    </ng-container>
    <ng-template #newContractModifications let-contract="contract">
      <div class="mt-2 col-12 pt-0 pb-2 mb-2" *ngIf="contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']">
        <button appNoDblClick (click)="createNewContractModification (contract)"
          class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element"
          [disabled]="!disabledButtonNewContractModification(contract)">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i>{{'ContractModification.new'|translate}}</span>
        </button>
      </div>
    </ng-template>
  </ng-template>

  </ng-container>

  <!-- ANTECEDENTES
  <ng-container *ngIf="
contract['EXT_DATA_ANTECEDENT'] && contract['EXT_DATA_ANTECEDENT'].length > 0">
    <h2 class="mt-3">{{'Antecedentes del Contrato'|translate}}</h2>
    <span class="m-xs" *ngIf=" !contract['EXT_DATA_ANTECEDENT_LOADED']" class="leyenda">
      <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.Modifications.loading'| translate}}
    </span>
    <ng-container *ngIf="contract['EXT_DATA_ANTECEDENT'] && contract['EXT_DATA_ANTECEDENT'].length > 0">
      <div class="p-table ui-widget" *ngIf="contract['EXT_DATA_ANTECEDENT_LOADED']">
        <div class="p-table-wrapper">
          <p-table [value]="contract['EXT_DATA_ANTECEDENT']" [responsive]="true">
            <ng-template pTemplate="header">
              <tr>
                <th [style.width]="'20%'">{{'Incidencia'|translate}}</th>
                <th [style.width]="'30%'">{{'Fecha Aprobación'| translate}}</th>
                <th [style.width]="'20%'">{{'Presupuesto (+IVA)'|translate}}</th>
                <th [style.width]="'30%'">{{'Precio (+IVA)'| translate}}</th>
                <th [style.width]="'30%'">{{'Plazo (Meses)'| translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-antecedent>
              <tr>
                <td><span class="p-column-title">{{'Incidencia'|translate}}</span> {{antecedent.description}} </td>
                <td><span class="p-column-title">{{'Fecha de Aprobación'| translate}}</span> {{antecedent.agreementDate
                  | date: 'dd/MM/yyyy'}}</td>
                <td><span class="p-column-title">{{'Presupuesto (+IVA)'| translate}}</span> {{antecedent.budget |
                  currency: 'EUR'}}</td>
                <td><span class="p-column-title">{{'Precio (+IVA)'| translate}}</span> {{antecedent.price | currency:
                  'EUR' }}</td>
                <td><span class="p-column-title">{{'Precio (+IVA)'| translate}}</span> {{antecedent.period | currency:
                  'EUR'}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>
  </ng-container>
   FIN ANTECEDENTES -->








</ng-template>
<!-- TEMPLATE PARA LA ZONA DE CARPETAS DE FASE DE EJECUCION -->
<ng-template #contractExecution let-contract="contract">
  <div *ngIf="isExecutionMonitoringModuleEnabled()" class="p-h-xs"> {{ 'Contracts.continuationDossierPlan.activation' |
    translate }} <p-inputSwitch onLabel="Activado" offLabel="Desactivado"
      (onChange)="updatecontinuationDossierTracing(contract)" [(ngModel)]="contract.continuationDossierTracing"
      class="btn">
    </p-inputSwitch>
  </div>
  <h2 class="mt-1 mb-3 titleElement">{{'Contracts.ExecutionPhases.title' | translate}}</h2>
  <span class="m-xs" class="leyenda" *ngIf="!contract['EXT_DATA_EXECUTIONPHASES_LOADED']">
    <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.ExecutionPhases.loading'| translate}}
  </span>
  <ng-container
    *ngIf="contract['EXT_DATA_EXECUTIONPHASES_LOADED']===true&&contract['EXT_DATA_EXECUTIONPHASES'] && contract['EXT_DATA_EXECUTIONPHASES'].length > 0">
    <div class="p-table ui-widget">
      <div class="p-table-wrapper">
        <table style="width: 100%;">
          <thead class="p-table-thead">
            <tr>
              <th class="col-icon"></th>
              <th style="width: 40%;">{{'Contracts.ExecutionPhases.phase'|translate}}</th>
              <th style="width: 20%;">{{'Documents.creationDate'|translate}}</th>
              <th style="width: 10%;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_FACTURADO')"
                class="text-right"> {{'Contracts.ExecutionPhases.budget.amountInvoiced'|translate}}</th>
              <th style="width: 10%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_FACTURADO')"
                class="text-right">
              </th>
              <th style="width: 10%;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_RECONOCIDO')"
                class="text-right"> {{'Contracts.ExecutionPhases.budget.amountamountRecognised'|translate}}</th>
              <th style="width: 10%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_RECONOCIDO')"
                class="text-right">
              </th>
              <th style="width: 20;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_FECHA_VENCIM')" class="text-right">
                {{'Contracts.ExecutionPhases.dueDate'|translate}}</th>
              <th style="width: 20%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_FECHA_VENCIM')"
                class="text-right">
              </th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody *ngFor="let executionPhase of contract['EXT_DATA_EXECUTIONPHASES']" class="p-table-tbody">
            <tr>
              <td>
                <span>
                  <i *ngIf="executionPhase.executionStatus == 'CLOSED'" aria-hidden="true"
                    class="fas fa-folder fa-lg"></i>
                  <i *ngIf="executionPhase.executionStatus == 'RUNNING'" aria-hidden="true" class=" far fa-folder-open
                    fa-lg"></i>
                  <span *ngIf="executionPhase.executionStatus == 'PAUSED'" style=" color: rgb(192, 191, 191);"
                    pTooltip="Carpeta bloqueada porque el documento contable asociado está en Intervención">
                    <i aria-hidden="true" class=" far fa-folder-open fa-lg"></i>
                  </span>
                </span>
              </td>
              <td class="text-truncate">
                <span style="line-height: 2em;">{{executionPhase.name}}</span>
              </td>
              <td class="text-truncate">
                <span style="line-height: 2em;">{{executionPhase.creationDate | date:'dd/MM/yyyy'}}</span>
              </td>
              <!--
              <td class="text-center">
                {{executionPhase.creationDate | date: 'dd/MM/yyyy'}}
              </td>
              <td class="text-left">{{executionPhase.phase.description}}</td>
              -->
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_IMPORTE_FACTURADO')" class="text-right">
                {{executionPhase.customFields?.DIV_EJEC_IMPORTE_FACTURADO | currency: 'EUR'}}</td>
              <td
                *ngIf="!executionPhase.customFields || executionPhase.customFields.DIV_EJEC_IMPORTE_FACTURADO === undefined"
                class="text-right"></td>
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_IMPORTE_RECONOCIDO')" class="text-right">
                {{executionPhase.customFields?.DIV_EJEC_IMPORTE_RECONOCIDO | currency: 'EUR'}}</td>
              <td *ngIf="!isDefined(executionPhase, 'DIV_EJEC_IMPORTE_RECONOCIDO')" class="text-right"></td>
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_FECHA_VENCIM')" class="text-right">
                {{executionPhase.customFields?.DIV_EJEC_FECHA_VENCIM | date: 'dd/MM/yyyy'}}</td>
              <td *ngIf="!isDefined(executionPhase, 'DIV_EJEC_FECHA_VENCIM')" class="text-right"> </td>
              <td class="text-right">
                <div class="btn-group">
                  <button *ngIf="isButtonReopenVisible (executionPhase)" appNoDblClick aria-expanded="false"
                    [disabled]="buttonsDisabled(contract, executionPhase) | async"
                    class="btn btn-sm t-action-button btn-primary" title="Reabrir"
                    (click)="reopenExecutionPhase(contract, executionPhase)">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </button>
                  <button *ngIf="!isExecutionPhaseClosed (executionPhase)" appNoDblClick aria-expanded="false"
                    [disabled]="buttonOpenActionsDisabled(contract, executionPhase) | async"
                    class="btn btn-sm t-action-button btn-primary" title="Gestionar"
                    (click)="openExecutionPhaseActions (executionPhase)">
                    <i aria-hidden="true" class="fas fa-tasks"></i>
                  </button>
                  <button *ngIf="!isExecutionPhaseClosed (executionPhase)"
                    class="btn btn-sm t-action-button btn-primary" type="button"
                    [disabled]="buttonsDisabled(contract, executionPhase) | async"
                    (click)="editExecutionDivision(contract,executionPhase)" title="{{ 'General.edit' | translate}}">
                    <i class="fas fa-pen" aria-hidden="true"></i>
                  </button>
                  <button *ngIf="!isExecutionPhaseClosed (executionPhase)"
                    class="btn btn-sm t-action-button btn-primary" type="button"
                    [disabled]="buttonDeleteDisabled(contract,executionPhase) | async"
                    (click)="deleteExecutionDivision(contract,executionPhase)"
                    title="{{ 'General.delete' | translate}}">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm t-action-button btn-primary" type="button"
                    (click)="showExecutionDivisionDocuments(executionPhase)" title="{{ 'Documents.list' | translate}}">
                    <i class="fas fa-file-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-container *ngTemplateOutlet="newExecutionPhases; context: { contract: contract }"></ng-container>
  <ng-template #newExecutionPhases let-contract="contract">
    <div class="row">
      <div class="mt-2 col-12 pt-0 pb-2 mb-2">
        <button type="button" class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element"
          (click)="editExecutionDivision(contract)" [disabled]="buttonsDisabled(contract, executionPhase) | async"
          title="{{ 'General.add' | translate}} {{'Contracts.ExecutionPhases.name'|translate }}">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i> {{ 'General.add' | translate}}
            {{'Contracts.ExecutionPhases.name' | translate}}</span>
        </button>
      </div>
    </div>
    <div class="row">
      <!--div class="col-12">
        <p-inplace closable="closable" (onDeactivate)="newExecutionPhase(contract,newname)"><i aria-hidden="true"
            class="mr-2 fas fa-lg fa-plus"></i>
          <span pInplaceDisplay
            class="plForm-element btn btn-sm btn-outline-secondary btn-list text-left btn btn-sm t-action-button btn-primary">
            {{'+  Crear carpeta de ejecución'}}
          </span>
          <span pInplaceContent>
            <input type="text" [(ngModel)]="this.newname" pInputText
              class="plForm-element btn btn-sm btn-outline-secondary btn-list text-left btn btn-sm t-action-button btn-primary">
          </span>
        </p-inplace>
      </div-->
      <!--div class="col-6">
        <button appNoDblClick (click)="getName(contract, newname)"
          class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i>Crear fase
            de ejecución</span>
        </button>
      </div-->
    </div>
  </ng-template>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE INDICADORES KPIS -->
<ng-template #contractKpis let-contract="contract">
  <h2 class="mt-4 mb-2">{{'Contracts.kpis.title'|translate}}</h2>
  <div class="p-table ui-widget">
    <div class="p-table-wrapper">
      <p-table [columns]="kpisDateList" [frozenColumns]="getKpisColumnasFijas()" [value]="getKpisTypeList()"
        [scrollable]="true" scrollHeight="200px" frozenWidth="33%">
        <ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" style="width:90px">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [ngClass]="col.date? 'text-right':''">
              <span class="d-none d-sm-block"><i *ngIf="col.date" class="fa fas fa-lg fa-calendar"
                  pTooltip="{{ col.date | date:'dd/MM/yyyy'}}"></i> {{col.header}}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns; let i = index" [ngClass]="col.date?'text-right':'text-truncate'">
              <span *ngIf="!col.date" pTooltip="{{rowData.kpiDescription}}">{{rowData.kpiDescription}}</span>
              <span *ngIf="col.date" class="pr-2">{{getKpiByTypeAndDate(rowData.kpiId,col).value}} <i
                  class="fa fas fa-lg" [ngClass]="getKpiIcon(rowData.kpiId,col)"
                  pTooltip="{{getKpiByTypeAndDate(rowData.kpiId,col).levelDescription}}"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA PLANIFICACION DE EXPEDIENTES DE CONTINUACION-->
<ng-template #continuationDossierPlan let-contract="contract">
  <h2 class="mt-4 mb-2">{{'Contracts.continuationDossierPlan.title'|translate}}</h2>
  <planning [id]="dossierId" [divisionId]="getSimpleIdentifierFromString(contract.division)" [continuationPlan]="true">
  </planning>
</ng-template>